<template>
  <BaseServerSyncDataTable
    :headers="filteredHeaders"
    :items="vwSummarySearches"
    :search="true"
    :searchText.sync="searchText"
    :loading="loading"
    :searchTotal="searchTotal"
    :searchSortBy.sync="searchSortBy"
    :searchDescending.sync="searchDescending"
    :searchPage.sync="searchPage"
    :searchRowsPerPage.sync="searchRowsPerPage"
    itemKey="ApplicationId"
    :expanded.sync="expanded"
    single-expand
    show-expand
  >
    <!-- //templateTodo: uncomment use custom search params-->
    <template v-slot:searchParams>
      <VwSummarySearchParams></VwSummarySearchParams>
    </template>
    <template v-slot:item.links="{ item }">
      <span>
        <BaseTooltipButton
          v-if="item.ContactId"
          small
          iconColor="primary"
          icon="mdi-account"
          @click="
            $router.push({
              name: 'staffForm',
              query: { contactId: item.ContactId },
            })
          "
          >Go To Contact
        </BaseTooltipButton>
        <BaseTooltipButton
          v-if="item.PropertyId"
          small
          iconColor="primary"
          icon="mdi-home"
          @click="
            $router.push({
              name: 'staffForm',
              query: { propertyId: item.PropertyId },
            })
          "
          >Go To Taxable Property
        </BaseTooltipButton>
        <BaseTooltipButton
          v-if="item.ApplicationId"
          small
          iconColor="primary"
          icon="mdi-file-document"
          @click="
            $router.push({
              name: 'staffForm',
              params: { appId: item.ApplicationId },
            })
          "
          >Go To Application
        </BaseTooltipButton>
      </span>
    </template>
    <template v-slot:item.StatusDate="{ item }">{{
      item.StatusDate | formatDateTime
    }}</template>
    <template v-slot:item.RefundAmount="{ item }">{{
      item.RefundAmount | formatMoney
    }}</template>
    <template v-slot:expanded-item="{ item, headers }">
      <td :colspan="headers.length" class="pa-2">
        <v-row justify="start">
          <v-col cols="12" md="2">
            <span class="font-weight-medium"
              >{{ item.FirstName }} {{ item.LastName }}
            </span>
            <div
              class="pointer d-inline"
              v-if="showSSN"
              @click="showSSN = false"
            >
              {{ item.Ssn }}
            </div>
            <div
              class="pointer primary--text d-inline"
              v-else
              @click="showSSN = true"
              >- show SSN -</div
            >

            <div v-if="item.ParcelId">
              <span class="font-weight-medium">Parcel</span> {{ item.ParcelId }}
            </div>
            <div v-if="item.ApplicationPeriod">
              <span class="font-weight-medium" v-if="item.ApplicationPeriod"
                >Application Period
              </span>
              {{ item.ApplicationPeriod }}
            </div>
          </v-col>
          <v-col cols="12" md="3" class="text-left">
            <span class="font-weight-medium d-block">Property Address </span>
            <div>
              {{ item.StreetAddress1 }}
            </div>
            <div v-if="item.StreetAddress2">
              {{ item.StreetAddress2 }}
            </div>
            <div> {{ item.City }}, {{ item.StateAbr }} {{ item.Zip }} </div>
          </v-col>
          <v-col cols="12" md="3" class="text-left">
            <div v-if="item.Phone">
              <span class="font-weight-medium">Phone</span> {{ item.Phone }}
            </div>
            <div v-if="item.Email">
              <span class="font-weight-medium">Email </span
              ><a :href="`mailto:${item.Email}`">
                {{ item.Email }}
              </a>
            </div>
          </v-col>
          <v-col v-if="item.StatusId" cols="12" md="3" class="text-left">
            <div v-if="item.Status">
              <span class="font-weight-medium">Status</span>
              {{ item.StatusCode }} - {{ item.Status }}
            </div>
            <div v-if="item.Reason">
              <span class="font-weight-medium">Reason</span>
              {{ item.ReasonNumber }} - {{ item.Reason }}
            </div>
            <div v-if="item.StatusDate">
              <span class="font-weight-medium">StatusDate</span>
              {{ item.StatusDate | formatDateTime }}
            </div>
            <div v-if="item.StatusBy">
              <span class="font-weight-medium">StatusBy</span>
              {{ item.StatusBy }} -
              <a :href="`mailto:${item.StatusByEmail}`">
                {{ item.StatusByEmail }}
              </a>
            </div>
          </v-col>
        </v-row>
      </td>
    </template>
  </BaseServerSyncDataTable>
</template>

<script>
import { get, sync, commit, call } from 'vuex-pathify'
//templateTodo: uncomment use custom search params
import VwSummarySearchParams from '@components/search/VwSummarySearchParams'

export default {
  name: 'VwSummarySearchSearchTable',
  components: {
    //templateTodo: uncomment use custom search params
    VwSummarySearchParams,
  },
  data: () => ({
    showSSN: false,
    expanded: [],
  }),
  created() {
    this.searchVwSummarySearches()
  },
  computed: {
    ...get('vwSummarySearch', ['vwSummarySearches', 'loading']),
    ...sync('vwSummarySearch', [
      'searchTotal',
      'searchPage',
      'searchSortBy',
      'searchDescending',
      'searchRowsPerPage',
      'searchText',
    ]),
    headers() {
      return [
        {
          text: '',
          align: 'center',
          sortable: false,
          value: 'links',
          visible: true,
        },
        {
          text: 'Application Number',
          align: 'center',
          sortable: true,
          value: 'ApplicationNumber',
          visible: true,
        },
        {
          text: 'Contact Id',
          align: 'center',
          sortable: true,
          value: 'ContactId',
          visible: false,
        },
        {
          text: 'First Name',
          align: 'center',
          sortable: true,
          value: 'FirstName',
          visible: true,
        },
        {
          text: 'Last Name',
          align: 'center',
          sortable: true,
          value: 'LastName',
          visible: true,
        },
        {
          text: 'SSN',
          align: 'center',
          sortable: true,
          value: 'Ssn',
          visible: false,
        },
        {
          text: 'Phone',
          align: 'center',
          sortable: true,
          value: 'Phone',
          visible: false,
        },
        {
          text: 'Property Id',
          align: 'center',
          sortable: true,
          value: 'PropertyId',
          visible: false,
        },
        {
          text: 'Street Address 1',
          align: 'center',
          sortable: true,
          value: 'StreetAddress1',
          visible: true,
        },
        {
          text: 'Street Address 2',
          align: 'center',
          sortable: true,
          value: 'StreetAddress2',
          visible: false,
        },
        {
          text: 'County Id',
          align: 'center',
          sortable: true,
          value: 'CountyId',
          visible: false,
        },
        {
          text: 'City Id',
          align: 'center',
          sortable: true,
          value: 'CityId',
          visible: false,
        },
        {
          text: 'City',
          align: 'center',
          sortable: true,
          value: 'City',
          visible: true,
        },
        {
          text: 'County',
          align: 'center',
          sortable: true,
          value: 'County',
          visible: true,
        },
        {
          text: 'Parcel Id',
          align: 'center',
          sortable: true,
          value: 'ParcelId',
          visible: true,
        },
        {
          text: 'State Id',
          align: 'center',
          sortable: true,
          value: 'StateId',
          visible: false,
        },
        {
          text: 'State Abr',
          align: 'center',
          sortable: true,
          value: 'StateAbr',
          visible: false,
        },
        {
          text: 'State',
          align: 'center',
          sortable: true,
          value: 'State',
          visible: false,
        },
        {
          text: 'Zip',
          align: 'center',
          sortable: true,
          value: 'Zip',
          visible: false,
        },
        {
          text: 'Property Is Active',
          align: 'center',
          sortable: true,
          value: 'PropertyIsActive',
          visible: false,
        },
        {
          text: 'Most Recent Property Period',
          align: 'center',
          sortable: true,
          value: 'MostRecentPropertyPeriod',
          visible: false,
        },
        {
          text: 'Application Id',
          align: 'center',
          sortable: true,
          value: 'ApplicationId',
          visible: false,
        },
        {
          text: 'Postmark Date',
          align: 'center',
          sortable: true,
          value: 'PostmarkDate',
          visible: false,
        },
        {
          text: 'Application Period Id',
          align: 'center',
          sortable: true,
          value: 'ApplicationPeriodId',
          visible: false,
        },
        {
          text: 'Application Period',
          align: 'center',
          sortable: true,
          value: 'ApplicationPeriod',
          visible: false,
        },
        {
          text: 'Refund Amount',
          align: 'center',
          sortable: true,
          value: 'RefundAmount',
          visible: true,
        },
        {
          text: 'Status Id',
          align: 'center',
          sortable: true,
          value: 'StatusId',
          visible: false,
        },
        {
          text: 'Status Code',
          align: 'center',
          sortable: true,
          value: 'StatusCode',
          visible: true,
        },
        {
          text: 'Status',
          align: 'center',
          sortable: true,
          value: 'Status',
          visible: false,
        },
        {
          text: 'Reason Id',
          align: 'center',
          sortable: true,
          value: 'ReasonIds',
          visible: false,
        },
        {
          text: 'Reason Numbers',
          align: 'center',
          sortable: true,
          value: 'ReasonNumbers',
          visible: true,
        },
        {
          text: 'Reason',
          align: 'center',
          sortable: true,
          value: 'Reasons',
          visible: false,
        },
        {
          text: 'Status Date',
          align: 'center',
          sortable: true,
          value: 'StatusDate',
          visible: false,
        },
        {
          text: 'Status Created By Id',
          align: 'center',
          sortable: true,
          value: 'StatusCreatedById',
          visible: false,
        },
        {
          text: 'Status By',
          align: 'center',
          sortable: true,
          value: 'StatusBy',
          visible: false,
        },
        {
          text: 'Status By Email',
          align: 'center',
          sortable: true,
          value: 'StatusByEmail',
          visible: false,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter((h) => h.visible)
    },
  },
  methods: {
    searchVwSummarySearches: call('vwSummarySearch/searchVwSummarySearches'),
  },
}
</script>

<style></style>
